export interface IMLSkill {
    id: string;
    name: string;
    status: MLSkillStatus;
    processor: MLProcessor;
    version: number;
    predictions: number;
    modelId: string;
    currentVersion: number;
    previousVersion: number;
    description: string;
    createdOn: Date;
    modifiedOn: Date;
    inputDescription: string;
    outputDescription: string;
    inputType: string;
}

export enum MLSkillStatus {
    Deploying = 'Deploying',
    Available = 'Available',
    Unavailable = 'Unavailable',
    Updating = 'Updating',
    Failed = 'Failed',
    Purged = 'Purged',
}

export enum MLProcessor {
    CPU = 'CPU',
    GPU = 'GPU',
}
